/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import type { DisplayProps } from "styled-system";
import { display } from "styled-system";
import * as CommonNavigationStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Navigation";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";

// This extra padding is necessary when the stickywrapper is fixed, otherwise part of the content is hidden underneath the bar
export const DesktopStickyPadding = styled.div<DisplayProps & { gradeNavHeight: number }>`
    height: ${({ gradeNavHeight }) => gradeNavHeight + CommonNavigationStyles.NAV_HEIGHT_MOBILE}px;
    ${display};

    @media ${getBreakpoint("up", "lg")} {
        height: ${({ gradeNavHeight }) => gradeNavHeight + CommonNavigationStyles.NAV_HEIGHT}px;
    }
`;

export const StickyWrapper = styled(CommonNavigationStyles.StickyWrapper)`
    display: flex;
`;

export const NavWrapper = styled.ul`
    display: flex;
    position: relative;
    flex-grow: 1;
    justify-content: center;
    padding: 0;

    & > li:not(:last-child) {
        margin-${getDirection("right")}: ${theme.space[3]}px;
    }

    @supports (gap) {
        gap: ${theme.space[3]}px;

        & > li:not(:last-child) {
            margin-${getDirection("left")}: 0;
        }
    }
`;

export const BackButton = styled.a`
    display: flex;
    color: ${theme.colors.primaryWhite};

    svg {
        pointer-events: none;
    }

    ${focusStyle};
`;

export const DesktopNav = styled.nav.attrs(() => ({
    className: "container",
}))`
    display: none;
    align-items: center;
    padding: 0 !important; /* Overwrite CSS */

    @media ${getBreakpoint("up", "lg")} {
        display: flex;
    }
`;

export const MobileNav = styled.nav`
    position: relative;
    width: 100%;

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const MobileNavHeader = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    height: ${({ disabled }) => (disabled ? 0 : "auto")};
    padding: 12px ${theme.space[3]}px;
    transition: height 0.4s;
`;

export const MobileNavTitle = styled.button<{ hasBasketButton?: boolean }>`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;

    ${focusStyle};
`;

export const MobileNavList = styled.ul`
    display: none;
    position: absolute;
    top: 64px; /* height MobileNavHeader */
    left: 0;
    right: 0;
    width: 100%;
    height: 0;
    padding: 0;
    background-color: ${theme.colors.primaryBlack};
    border-top: 1px solid transparent;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    transition: height ease-in 0.4s;
    overflow: hidden;
    pointer-events: none;
`;

export const MobileNavButton = styled.button<{ hasBasketButton?: boolean }>`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;

    &[aria-expanded="true"] ~ ${MobileNavList} {
        display: block;
        height: auto;
        min-height: 120px;
        padding: ${theme.space[1]}px 0;
        border-top-color: ${theme.colors.grey5};
        pointer-events: initial;
    }

    ${focusStyle};
`;

export const Badge = CommonNavigationStyles.Badge;

export const StepText = CommonNavigationStyles.StepText;

export const StepIndicator = CommonNavigationStyles.StepIndicator;
